// Explicit WebSocket channels a screen wants (04 §7.3, e.g. `system:<id>` while the system screen is
// open). The socket hook subscribes to whatever is wanted, again after every reconnect.
import { useEffect } from 'react';
import { create } from 'zustand';

interface ChannelState {
  /** Channel → number of mounted screens that want it. */
  wanted: Record<string, number>;
  add(channel: string): void;
  remove(channel: string): void;
}

export const useChannels = create<ChannelState>()((set) => ({
  wanted: {},
  add: (channel) =>
    set((s) => ({ wanted: { ...s.wanted, [channel]: (s.wanted[channel] ?? 0) + 1 } })),
  remove: (channel) =>
    set((s) => {
      const wanted = { ...s.wanted };
      const left = (wanted[channel] ?? 0) - 1;
      if (left > 0) wanted[channel] = left;
      else delete wanted[channel];
      return { wanted };
    }),
}));

export function useChannelSubscription(channel: string | undefined): void {
  useEffect(() => {
    if (!channel) return;
    useChannels.getState().add(channel);
    return () => useChannels.getState().remove(channel);
  }, [channel]);
}
